module.exports = "<span ng-style=\"circleStyle\">{{ abbreviatedName }}</span>\n";